<template>
  <div v-if="product.imagenes.length>0" >

   
    <div  @mouseover="details = true"  @mouseout="details = false" >
      <!-- name: 'producto' , params: {id:product.id} -->
        <div  class="single-products">
          <div class="productinfo text-center">
            <!-- <h1 class="title-producto" @click="vistaRapida(product)">{{product.nombre}} <i class="fa fa-search fa-pull-right" style="color:#fff; font-size:18px; padding:5px; cursor:pointer" title="Vista Rápida"></i></h1> -->
            <h1 class="title-producto">{{product.nombre}} </h1>
            <div v-if="product.imagenes.length>1" class="view-product">
                <figure v-for="(img,index) in product.imagenes" :key="index">
                    <img  :class="`img${img.orden} ${[img.orden == 1 ? '' : 'display']}`" width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                </figure>
            </div>
            <div v-else class="view-product">
                <figure v-for="(img,index) in product.imagenes" :key="index" @click="addProducto(product)">
                    <img width="100%" :src="`${dominio}/img/productos/${img.nombre}`" alt="" />
                </figure>
            </div>
            <div class="datos-producto">
              <strong> </strong>{{ product.descripcion}}
            </div>
            
            <!-- <h2>$ {{product.precio_venta }}</h2>

            <slide-x-right-transition>
                <p >{{product.nombre}}</p>
            </slide-x-right-transition>
            <scale-transition >
                <a class="btn btn-default add-to-cart" @click="saveToCart(product)" href="#">Agregar al Carrito</a>
            </scale-transition> -->
          </div>
        </div>
        
    </div>
    <zoomimagen :scroll="scroll" :modalz="modalz" :imagenes="imagenes" @cerrarModalz="cerrarModalz"></zoomimagen>
    <!-- <customproducto  :scroll="scroll" :modalp="modalp" :producto="producto" @cerrarModalp="modalp=0"></customproducto> -->
  </div>
</template>

<script>

  import { SlideXRightTransition,ScaleTransition } from 'vue2-transitions'
    import { mapMutations } from 'vuex'
   import customproducto from './customProducto'
   import zoomimagen from './ZoomImagen.vue'

export default {
  name: 'product',
  props: ['product','scroll'],  
  components: {
    SlideXRightTransition,ScaleTransition,
    customproducto,
    zoomimagen
  },
  data() {
    return { details: false,
            store:false, 
            dominio:this.$store.state.dominio,
            verProd:0,
            nombre:'',
            imagen:'',
            descripcion:'',
            producto:{},
            modalp:0,
            imagenes:[],
            modalz:0
            }
  },
    watch: {
      modalp(val) {
         const ahora = new Date();

  const horas = String(ahora.getHours()).padStart(2, '0');
  const minutos = String(ahora.getMinutes()).padStart(2, '0');
  const segundos = String(ahora.getSeconds()).padStart(2, '0');
    const milisegundos = String(ahora.getMilliseconds()).padStart(3, '0');

  const horaCompleta = `${horas}:${minutos}:${segundos}.${milisegundos}`;
        console.log("modalp cambió a:", val,horaCompleta);
      }
    },
    methods : {
       ...mapMutations(['saveToCart']),
      
       vistaRapida(producto){
         this.verProd=1
         this.producto=producto.imagen
         this.nombre=producto.nombre
         this.descripcion=producto.descripcion
       },
       addProducto(value){
        this.imagenes=value.imagenes
        this.producto=value
        this.modalp=1
        this.modalz=1
      },
       cerrarModalz(value){
            this.modalz=value
      },
      //  cerrarModalp(value){
      //   this.modalp=value
      //  },
     
    },
    created() {
      this.$route.name == 'store' ? this.store = true : ''
    },
    
}
</script>

<style >
.product-disabled{
  opacity:0.7;
}
.flying-badge{
    position: absolute;
    right: -27px;
    border-radius: 40px;
    padding: 9px;
}
.card-title,.card-text{
  text-shadow:1px 2px 8px black;
}
.view-product{
  cursor:pointer;
}
.display{
      display:none;
}
.view-product:hover .img1{
    display:none;
}
.view-product:hover .img2{
    display:block;
}
</style>
